<div class="content-div">
  <app-biq-progress-bar 
    [questNo]="questNo"
    [totalQuestions]="totalQuestions"
  ></app-biq-progress-bar>

  <form class="form-div" [formGroup]="form">
    <p class="heading">How do you describe your race/ethnicity?</p>
    <p class="sub-heading">Select all that apply</p>

    <div formArrayName="ethnicities" class="ethnicity-container">

      @for (option of ethnicityOptions; track $index) {
        <mat-checkbox
          [formControlName]="$index"
          [class]="form.get('ethnicities')?.value[$index] ? 'checked-item' : ''"
          [disabled]="shouldDisableCheckbox($index)"
        >
          {{ option.label }}
        </mat-checkbox>
      }

      <mat-checkbox 
        [formControl]="selfDescribeControl"
        [disabled]="isSelfDescribeDisabled()"
        [class]="selfDescribeControl.value ? 'checked-item' : ''"
      >
        <div class="self-describe-container">
          <label for="selfDescribeInput">Prefer to self describe</label>
          <input
            id="selfDescribeInput"
            matInput
            [formControl]="selfDescribeText"
            [disabled]="!selfDescribeControl.value"
            maxlength="200"
          />
        </div>
      </mat-checkbox>

      @if (form.get('ethnicities')?.hasError('required') && form.get('ethnicities')?.touched) {
        <mat-error class="input-error">
          This question is required.
        </mat-error>
      }

      @if (selfDescribeText.invalid) {
        @if (selfDescribeText.hasError('required')) {
          <mat-error class="input-error">
            Please describe your ethnicity
          </mat-error>
        }
        @if (selfDescribeText.hasError('minlength')) {
          <mat-error class="input-error">
            Minimum 3 characters required
          </mat-error>
        }
        @if (selfDescribeText.hasError('maxlength')) {
          <mat-error class="input-error">
            Maximum 200 characters allowed
          </mat-error>
        }
      }

    </div>

    <app-biq-button (buttonEmitter)="onClickContinue()"></app-biq-button>
  </form>
</div>